module.exports = __webpack_public_path__ + "static/media/skyland128.0cc58904.png";